import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { AgreementsService } from 'src/app/pages/agreements/services/agreements.service';
import { findRateTimeBlock } from 'src/app/pages/agreements/utilities/time-block-helper';
import { TimeBlock } from 'src/app/shared/graphql/graphql-types';
import { RateSchedule } from 'src/app/shared/models/gql/rate.model';

@Component({
  standalone: true,
  imports: [CommonModule, IonicModule],
  selector: 'app-rate-schedule',
  templateUrl: './rate-schedule.component.html',
  styleUrls: ['./rate-schedule.component.scss'],
})
export class RateScheduleComponent implements OnChanges {
  // Rate schedule
  @Input() rateSchedule: RateSchedule;

  // Rate time block used in structured rates
  @Input() rateTimeBlock: TimeBlock;

  // Day of the week description
  dayOfWeek: string;

  // Time of the day description
  timeOfDay: string;

  timeBlock: string;

  constructor(private agreementsService: AgreementsService) {}

  ngOnChanges(): void {
    this.dayOfWeek = this.agreementsService.getDayOfWeekDescription(this.rateSchedule);
    this.timeOfDay = this.agreementsService.getTimeOfDayDescription(this.rateSchedule);
    this.timeBlock = this.rateTimeBlock ? findRateTimeBlock(this.rateTimeBlock).description : null;
  }
}
